import { createSelector } from 'reselect';
import selectVisiblePriceTypesByTicketType from './selectVisiblePriceTypesByTicketType';
import selectTicketTypeByReservation from './selectTicketTypeByReservation';

export default createSelector(
    selectTicketTypeByReservation,
    state => state,
    (ticketType, state) => selectVisiblePriceTypesByTicketType(state, ticketType?.hash),
);
